import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppToastService } from '../../shared/toast-service/toast-service';

/**
 * Error Interceptor for API calls
 */
@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    constructor(private toastService: AppToastService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                let errorMessage = 'An unexpected error occurred';

                if (error.error instanceof ErrorEvent) {
                    // Client-side error
                    errorMessage = `Error: ${error.error.message}`;
                } else {
                    // Server-side error
                    if (error.error && error.error.Error) {
                        errorMessage = error.error.Error.Message || error.message;
                    } else if (error.status === 0) {
                        errorMessage = 'Unable to connect to the server. Please check your internet connection.';
                    } else if (error.status === 401) {
                        errorMessage = 'Unauthorized access. Please login again.';
                    } else if (error.status === 403) {
                        errorMessage = 'Access forbidden. You do not have permission to perform this action.';
                    } else if (error.status === 404) {
                        errorMessage = 'The requested resource was not found.';
                    } else if (error.status === 500) {
                        errorMessage = 'Internal server error. Please try again later.';
                    } else {
                        errorMessage = `Error ${error.status}: ${error.message}`;
                    }
                }

                // Show error toast
                this.toastService.show(errorMessage, {
                    classname: 'bg-danger text-light',
                    delay: 5000
                });

                return throwError(() => error);
            })
        );
    }
}
